module.exports = __webpack_public_path__ + "static/media/image002.d498a4da.webp";